module.exports = __webpack_public_path__ + "img/banner_generic_left.7ae107a3.jpg";